// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login .login-ad-modal .my-urbanimmersive .ui.buttons .button:first-child,\n.login .login-ad-modal .my-urbanimmersive h2.login-ad-heading strong {\n  color: #7CD3F7 !important;\n}\n.login .login-ad-modal .my-urbanimmersive .ui.buttons .button:first-child:hover {\n  background-color: #545454 !important;\n}\n.login .login-ad-modal .my-urbanimmersive a.ui.primary.button {\n  background-color: #7CD3F7 !important;\n}\n", ""]);
// Exports
module.exports = exports;
